var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlants1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 188,
    viewBox: "0 0 80 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9812 159.294C32.9812 159.294 -5.0955 101.225 0.576045 87.8972C6.24759 74.569 26.3558 97.4228 26.3558 97.4228C26.3558 97.4228 -3.20069 19.3359 16.7915 2.2182C36.7837 -14.8996 43.4478 72.6742 43.4478 72.6742C43.4478 72.6742 61.4936 22.2104 75.8142 41.2487C90.1349 60.2871 53.9014 100.271 53.9014 100.271C53.9014 100.271 78.65 101.225 71.9473 117.415C65.2445 133.605 47.1987 150.735 47.1987 150.735L32.9812 159.294Z",
    fill: "#36CA5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2602 146.688C25.2602 146.688 1.59441 124.453 0.872577 114.463C0.150744 104.473 15.9408 116.616 22.3858 120.908C28.8307 125.2 5.89962 92.937 6.60857 69.2712C7.31751 45.6054 20.2332 54.9377 24.5384 64.9789C28.8436 75.0201 30.9833 84.3137 33.1488 86.4921C35.3143 88.6705 38.8848 69.9931 48.2042 75.0072C63.1049 83.0376 38.8848 110.145 43.899 115.172C48.9131 120.199 60.398 93.6589 66.134 108.005C71.87 122.352 47.4823 148.157 47.4823 148.157",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3156 145.244L22.3857 91.4677",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9961 117.995L38.1629 101.509",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6497 128.758L36.7321 133.772L46.7733 126.605",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5323 142.164H11.0813L16.1212 186.904H56.4923L61.5323 142.164Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlants1);
export default __webpack_public_path__ + "static/media/plants 1.0f9f442f48511d5830e4e408b5ddcfd5.svg";
export { ForwardRef as ReactComponent };